// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"296":"ea88be26","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"296":"a34c2180cef16e146389","678":"2c1b514a993257ba8801","883":"b01d750cbd61250e0b69"}[chunkId] + ".js";
};